'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isInitialised;
function isInitialised(globalSnowplowName) {
  return typeof window[globalSnowplowName] !== 'undefined';
}
module.exports = exports['default'];